export const Trident = ({ className = "h-9 w-9", id = "trident" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <defs>
      <linearGradient id={`${id}-grad`} x1="8" y1="4" x2="40" y2="44" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#7DD3FC" />
        <stop offset="0.5" stopColor="#2E7CF6" />
        <stop offset="1" stopColor="#1A64FF" />
      </linearGradient>
    </defs>
    <path d="M24 3 L20.2 9.6 H27.8 Z" fill={`url(#${id}-grad)`} />
    <path d="M9.5 7.5 L6.6 12.6 H12.4 Z" fill={`url(#${id}-grad)`} />
    <path d="M38.5 7.5 L35.6 12.6 H41.4 Z" fill={`url(#${id}-grad)`} />
    <path d="M24 9.6 V24" stroke={`url(#${id}-grad)`} strokeWidth="2.6" strokeLinecap="round" />
    <path d="M9.5 12.6 C9.5 21.5 15.5 26.5 24 28.4" stroke={`url(#${id}-grad)`} strokeWidth="2.6" strokeLinecap="round" />
    <path d="M38.5 12.6 C38.5 21.5 32.5 26.5 24 28.4" stroke={`url(#${id}-grad)`} strokeWidth="2.6" strokeLinecap="round" />
    <path d="M24 28.4 V41.5" stroke={`url(#${id}-grad)`} strokeWidth="2.6" strokeLinecap="round" />
    <path d="M20 41.5 H28" stroke={`url(#${id}-grad)`} strokeWidth="2.6" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="tria-logo">
    <Trident id={compact ? "trident-footer" : "trident-main"} className="h-9 w-9 drop-shadow-[0_0_14px_rgba(46,124,246,0.55)]" />
    <div className="flex flex-col leading-none">
      <span className="font-display text-[22px] font-semibold tracking-[0.22em] text-white">TRIA</span>
      {!compact && (
        <span className="mt-1 text-[10px] font-medium tracking-wide text-tria-subtle">
          Inteligência financeira para varejo e brechós
        </span>
      )}
    </div>
  </div>
);
